import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {
  AntibodyDomainsQuery,
  AntibodyDomainsQueryVariables,
} from 'molbio/adcs/conjugation-sites/__generated/AntibodyDomainsQuery';
import {
  ANTIBODY_DOMAINS_QUERY,
  AntibodyDomain,
  getAntibodyDomains,
} from 'molbio/adcs/conjugation-sites/antibodyDomainsQuery';

/**
 * Loads an antibody's domains for labeling its conjugation sites. Returns null while there is no antibody,
 * while the domains load, and if they can't be read, so callers show unlabeled sites until they arrive.
 */
export default function useAntibodyDomains(antibodyId: string | null): Array<AntibodyDomain> | null {
  const queryResult = useSkippableBenchlingQuery<AntibodyDomainsQuery, AntibodyDomainsQueryVariables>(
    ANTIBODY_DOMAINS_QUERY,
    {variables: {antibodyId: antibodyId ?? ''}, skip: antibodyId == null}
  );
  return queryResult.type === QueryResultType.SUCCESS ? getAntibodyDomains(queryResult.data) : null;
}
